import { useAuth } from "@/hooks/useAuth";
import { PATH } from "@/lib/enums";
import { Navigate } from "react-router-dom";
import Loading from "./Loading";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <Loading></Loading>;
  }
  if (!user) {
    const route = PATH.LOGIN;
    return <Navigate to={route} replace />;
  }

  return children;
};

export default ProtectedRoute;
